<template>
  <div>
    <shareItem
      v-show="isShareCome || $route.query && $route.query.sharetype =='browser'"
      :dlurl="dlurl"
      pageCode="5011001"
      v-isNoAppShare
    />
    <div class="ss1">
      <van-field class="text" v-model="text" rows="1" autosize type="textarea" placeholder="请输入" />
      <div class="tps"><img src="@/assets/atlas/up.png">以上内容可编辑</div>
      <div class="index-index-cates">
        <div class="index-cates-inner" v-for="(item,index) in fileList" :key="index">
          <div class="close" @click="deleteImgFun(index)">
            <img class="ba1" src="@/assets/atlas/clode@2x.png" />
          </div>
          <img :src="item.fileUrl" mode="widthFix" />
        </div>
      </div>
      <div class="index-atlas-button">
        <span class="send" @click="goShareFun">立即去分享</span>
      </div>
    </div>
  </div>
</template>
<script>
import http from "@/utils/axios";
import { isWeChatApplet } from "@/utils/util";
import utils from "@/utils/common";
import shareItem from "@/views/shareDiscovery/components/shareBtn";
export default {
  data() {
    return {
      fileList: [],
      text: "",
    };
  },
  components: { shareItem },
  created() {
    this.$loading.hide();
    this.onAtlasProductDetail();
  },
  methods: {
    onAtlasProductDetail: function () {
      var parmes = {
        atlasId: this.$route.query.atlasId || "",
        id: this.$route.query.discoverId,
      };
      http({
        url: "discover/appbees/discoveratlas/content/detail",
        method: "post",
        parmes: parmes,
      }).then((res) => {
        if (res.code == 200) {
          this.fileList = JSON.parse(JSON.stringify(res.data)).fileList;
          let productData = JSON.parse(JSON.stringify(res.data));
          let itemName = productData.itemName || "";
          let price = productData.price || "";
          let markingPrice = productData.markingPrice || productData.price;
          let modelSize = productData.modelSize || "";
          let content = productData.content || "";

          this.text =
            itemName +
              "\n售价：" +
              price +
              "\n原价：" +
              markingPrice +
              "\n尺寸：" +
              modelSize +
              "\n\n" +
              content || "";
        }
      });
      let prmes = {
        userId: "00000",
        userName_var: "",
        foundID_var: parmes.id,
      };
      if (localStorage.getItem("userInfo")) {
        let userInfo = JSON.parse(localStorage.getItem("userInfo"));
        gioPrmes.userId = userInfo.userId;
        gioPrmes.userName_var = userInfo.nickName;
      }
      gio("track", "userImageProductEnterDetails_var", prmes);
    },
    getContentHtml: function (content) {
      if (content) {
        return content.replace(/[\r\n]/g, "<br/>");
      }
      return "";
    },
    deleteImgFun(index) {
      this.fileList.splice(index, 1);
    },
    goShareFun() {
      this.$minicode.show({
        pageCode: "5011001",
        pageQueryParam: { id: this.$route.query.discoverId },
        isShow: "为了您有更好的体验，请您下载APP 或打开小程序",
      });
      let arr = this.fileList.map((item) => {
        return item.fileUrl;
      });
      utils.nativeMethod({
        tm: "4050102",
        tp: {
          discoverId: this.$route.query.discoverId,
          images: arr,
          copyText: this.text,
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.ss1 {
  height: 100%;
  padding-top: 40px;
  color: #999999;
  font-size: 24px;
  background-color: #fff;
  padding-left: 30px;
  .van-cell {
    padding: 0;
  }
  .van-cell::after {
    position: absolute;
    box-sizing: border-box;
    content: "";
    pointer-events: none;
    right: 0.4244rem;
    bottom: 0;
    left: 0.4244rem;
    border-bottom: 0;
    -webkit-transform: scaleY(0.5);
    transform: scaleY(0.5);
  }
  .index-index-cates {
    background-color: #ffffff;
    display: block;
    overflow: hidden;
    padding-bottom: 28px;
    width: 100%;
    padding-top: 20px;
  }
  .index-cates-inner {
    float: left;
    width: 20%;
    display: flex;
    flex-direction: column;
    height: 140px;
    align-items: center;
    justify-content: space-between;
    margin-right: 26px;
    position: relative;
    margin-bottom: 40px;
    .close {
      position: absolute;
      right: 0;
      top: 0;
      z-index: 1;
      margin-top: -20px;
      margin-right: -20px;
      .ba1 {
        width: 40px;
        height: 40px;
      }
    }
  }
  .index-cates-inner img {
    width: 150px;
    height: 150px;
  }
  .text {
    width: 690px;
    height: auto;
    font-size: 24px;
    color: #333333;
    border: 1PX solid #ddd;
    box-sizing: border-box;
    padding: 20px;
    /deep/textarea {
      color: #666;
    }
  }
}
.index-atlas-button {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  z-index: 10;
  background-color: white;
  height: 98px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 30px;
  height: 98px;
}
.index-atlas-button .send {
  flex: 1;
  height: 76px;
  background: rgba(248, 213, 65, 1);
  border-radius: 76px;
  text-align: center;
  line-height: 76px;
  font-size: 26px;
  margin-left: 30px;
  color: #333333;
}
.ss1 .tps {
  font-size:24px;
  color: #F8A651;
  position: relative;
  padding: 20px 0 24px 36px;
  img {
    width: 30px;
    height: 30px;
    position: absolute;
    top: 50%;
    left: 0;
    z-index: 1;
    margin-top: -16px;
  }
}
</style>